<template>
  <div class="header-bread-crumb">
    <Breadcrumb>
      <BreadcrumbItem
        v-for="item in headerBreadCrumbList"
        :to="item.path"
        :key="item.name"
      >
        {{ showTitle(item) }}
      </BreadcrumbItem>
    </Breadcrumb>
  </div>
</template>

<script>
export default {
  name: 'HeaderBreadCrumb',
  props: {
    headerBreadCrumbList: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    // 考虑国际化
    showTitle(item) {
      return (item.meta && item.meta.title) || item.name;
    },
  },
};
</script>

<style lang="less" scoped>
.header-bread-crumb {
  display: inline-block;
  vertical-align: top;
  padding: 24px;
}
</style>
